import styled from 'styled-components'
import { media } from 'styles/media'

import Container from 'components/layout/Container'
import { ParagraphXs } from 'components/display/Typography'

export const SectionContainer = styled(Container)`
  margin: 50px auto;

  ${media.md`
    margin: 110px auto;
  `}
`

export const HeaderCentered = styled.div`
  margin-bottom: 40px;

  ${media.md`
    text-align: center;
  `}

  h4 {
    color: ${({ theme }) => theme?.['-ds-core-300']?.value};

    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${media.md`
    margin-top: 32px;
    align-items: center;
  `}

  & * + * {
    margin-top: 16px;

    ${media.md`
      margin-top: 32px;
    `}
  }
`

export const SupportTextWrapper = styled(ParagraphXs)`
  a {
    display: block;
  }

  ${media.md`
    a {
      display: inline;
    }
  `}
`
